module.exports = __webpack_public_path__ + "static/cow-8d8b82c1682abbf7d4cb843a60cc1111.mp3";